var _path, _path2, _path3;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMessage = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19C9.42233 19 8.87814 18.7078 8.49302 18.1985L7.23721 16.5288C7.21209 16.4954 7.11163 16.4536 7.06977 16.4453H6.65116C3.16 16.4453 1 15.5019 1 10.8098V6.63544C1 2.94527 2.9507 1 6.65116 1H13.3488C17.0493 1 19 2.94527 19 6.63544V10.8098C19 14.5 17.0493 16.4453 13.3488 16.4453H12.9302C12.8633 16.4453 12.8047 16.4787 12.7628 16.5288L11.507 18.1985C11.1219 18.7078 10.5777 19 10 19ZM6.65116 2.25232C3.65395 2.25232 2.25581 3.64657 2.25581 6.63544V10.8098C2.25581 14.5835 3.55349 15.1929 6.65116 15.1929H7.06977C7.49674 15.1929 7.98233 15.4351 8.24186 15.7774L9.49767 17.4471C9.7907 17.8312 10.2093 17.8312 10.5023 17.4471L11.7581 15.7774C12.0344 15.41 12.4698 15.1929 12.9302 15.1929H13.3488C16.346 15.1929 17.7442 13.7987 17.7442 10.8098V6.63544C17.7442 3.64657 16.346 2.25232 13.3488 2.25232H6.65116Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9L14 9L11.7143 6",
    stroke: "#757575",
    strokeWidth: 0.951034,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8L11 11",
    stroke: "#757575",
    strokeWidth: 0.951034,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMessage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/message.30cf48be.svg";
export { ForwardRef as ReactComponent };